import { gql } from '@apollo/client';
import { EntityReminderFragment } from '../fragments/EntityReminderFragment';
/**
 * @const UpdateEntityReminderMutation
 * @since 1.0.0
 */
export const UpdateEntityReminderMutation = gql `
  mutation UpdateEntityReminderMutation($input: UpdateEntityReminderInput!) {
    updateEntityReminder(input: $input) {
      ...EntityReminderFragment
    }
  }

  ${EntityReminderFragment}
`;
